<template>
  <div class="col col-md-12 pl-0 pr-4 pb-3" id="textpage">
    <div class="card mr-2 border innerdoc">
      <div class="card-body p-4">
        <div class="template2">
          <div class="header col-md-12 mb-3">
            <div class="row">
              <div class="col-md-6 pl-0">
                <img :src="logo_one" class="mb-2 img-fluid logo-images-in-docs" alt="img">
              </div>
              <div class="col-md-6 text-right pr-0">
                <img :src="logo_two" class="mb-2 img-fluid logo-images-in-docs" alt="img">
              </div>
            </div>
          </div>
          <div class="clearfix"></div>
          <div class="picdetail">
            <div class="text-center mb-3">
              <div>
                <h3 class="mb-2 pb-2 border-bottom">Zusammenfassung</h3>
              </div>
              <div class="content mt-2">
                <div class="text-left" v-html="selectedDocument.description" style="white-space: pre-wrap;"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <p class="text-center border-top pb-3 position-absolute foot">
        Seite 2 von {{ (images.length % 2) === 0 ? parseInt(images.length / 2) + 2 : parseInt(images.length / 2) + 3 }}
        <span class="float-right">projectdocu.com</span>
      </p>
    </div>
  </div>
</template>
<script>

import {setAspectRatio} from '../../../common'

export default {
  props: ['textPage', "selectedDocument", 'theme' , 'logo_one', 'logo_two'],
  computed: {
    images() {
      return this.$store.state.photoDocumentation.photoContentImages
    }
  },

  mounted () {
    setAspectRatio()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/photoDocumentation/components/Preview/PreviewTextAreaContent.vue